import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Sparkles } from 'lucide-react';
import JwalekLogo from '@/components/JwalekLogo';

const AuthCallback = () => {
  const { loginWithSessionId } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Signing you in...');
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = location.hash || window.location.hash || '';
    const params = new URLSearchParams(hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    if (!sessionId) {
      setStatus('No session found');
      toast.error('Sign-in failed — no session id');
      setTimeout(() => navigate('/login', { replace: true }), 1500);
      return;
    }
    // Clear the hash from the URL
    try { window.history.replaceState(null, '', window.location.pathname); } catch {}

    (async () => {
      try {
        const user = await loginWithSessionId(sessionId);
        toast.success(`Welcome, ${user.name?.split(' ')[0] || 'friend'}!`);
        if (user.role === 'admin') {
          navigate('/admin', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      } catch (e) {
        toast.error(e.response?.data?.detail || 'Sign-in failed');
        setTimeout(() => navigate('/login', { replace: true }), 1500);
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[70vh] grid place-items-center px-4">
      <div className="jw-card p-8 text-center max-w-sm">
        <JwalekLogo size={28} />
        <div className="mt-6">
          <Sparkles className="w-8 h-8 mx-auto text-orange-400 animate-pulse" />
          <p className="mt-4" style={{ color: 'var(--jw-text-muted)' }}>{status}</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
